import React from 'react';
import SystemPrev from './SystemPrev';

/**
 * Reusable grid component for displaying system cards
 * 
 * @param {Object} props
 * @param {Array} props.systems - Array of system objects to display
 * @param {string} props.sysType - System type (private, public, followed)
 */
const SystemsGrid = ({ systems, sysType }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
      {systems.map(system => (
        <SystemPrev 
          system={system} 
          key={system._id} 
          sysType={sysType} 
        />
      ))}
    </div>
  );
};

export default SystemsGrid;
